import { SET_TURNOS_SELECCIONADOS } from "../ActionTypes";

const turnosSeleccionados = (state, { payload, type }) => {
  switch (type) {
    case SET_TURNOS_SELECCIONADOS:
      return {
        ...state,
        turnosSeleccionados: {
          ...state.turnosSeleccionados,
          loading: false,
          error: false,
          data: payload,
        },
      };

    default:
      return state;
  }
};

export default turnosSeleccionados;
